import { updatesData } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 text-center mb-12">
          最新动态
        </h2>

        <div className="relative">
          <div className="absolute left-5 md:left-8 top-0 bottom-0 w-px bg-background-300"></div>

          <div className="flex flex-col gap-8">
            {updatesData.map((item) => (
              <div key={item.id} className="relative pl-12 md:pl-16">
                <div
                  className={`absolute left-4 md:left-[27px] top-2 w-3 h-3 rounded-full border-2 z-10 ${
                    item.latest
                      ? 'bg-accent-500 border-accent-500'
                      : 'bg-background-100 border-background-300'
                  }`}
                ></div>

                <div
                  className={`p-5 rounded-2xl ${
                    item.latest
                      ? 'bg-background-50 border-l-[3px] border-l-accent-500'
                      : 'bg-background-50'
                  }`}
                >
                  <span className="text-xs text-foreground-400 mb-1.5 block">
                    {item.time}
                  </span>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                    {item.summary}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}